import { render as l } from "./ghl-ui.es1392.js";
import { mount as f, unmount as c } from "./ghl-ui.es1393.js";
function m(r) {
  return l(this, this.instance, r);
}
function d(r = {}) {
  const { id: n, ssr: t, props: e, head: o = !1, silent: s = !1, force: i = !1, anchorMetaName: a } = r;
  return f(this.instance, this, n, e, o, s, i, a, t);
}
function h(r = {}) {
  const { id: n } = r;
  c(this.instance, this, n);
}
const u = function(r, n, t, e) {
  return {
    instance: r,
    $: n,
    props: t,
    children: e,
    els: [],
    render: m,
    mount: d,
    unmount: h
  };
}, w = function(r, n, t, e) {
  return Array.isArray(n) ? u(r, { $: null }, null, n) : Array.isArray(t) ? u(r, n, null, t) : Array.isArray(e) ? u(r, n, t, e) : u(r, n, t, null);
};
export {
  w as c
};
